import React from 'react';
import ContentLoader from 'react-content-loader';
export default function SquareSkeletonLoader({
    uniquekey,
    height,
    width,
}: {
    uniquekey: string;
    height: number;
    width: number;
}) {
    return (
        <ContentLoader
            speed={5}
            height={height}
            width={width}
            uniquekey={uniquekey}
        >
            <rect x="0" y="0" rx="0" ry="0" width={width} height={height} />
        </ContentLoader>
    );
}
